import { createContext } from "react";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import type { ReferenceType, ExtendedRefs } from "@floating-ui/react";

import { usePoppable, type PoppableStyle } from "@/hooks/usePoppable";

type LinkPanelCtx = {
  setIsPoppableVisible: Dispatch<SetStateAction<boolean>>;
  isPoppableVisible: boolean;
  style: PoppableStyle | null;
  refs: ExtendedRefs<ReferenceType> | null;
};

export const linkPanelContext = createContext<LinkPanelCtx>({
  setIsPoppableVisible: () => {},
  isPoppableVisible: false,
  style: null,
  refs: null,
});

const { Provider } = linkPanelContext;

export function LinkPanelContext({
  children,
}: {
  children(props: Pick<LinkPanelCtx, "setIsPoppableVisible">): ReactNode;
}) {
  const { setIsPoppableVisible, isPoppableVisible, style, refs } = usePoppable({
    placement: "bottom",
    options: { offset: 6 },
  });

  return (
    <Provider
      value={{
        setIsPoppableVisible,
        isPoppableVisible,
        style,
        refs,
      }}
    >
      {children!({ setIsPoppableVisible })}
    </Provider>
  );
}
